import { render, staticRenderFns } from "./BatchOrderCreate.vue?vue&type=template&id=4c6c47c3&scoped=true"
import script from "./BatchOrderCreate.vue?vue&type=script&lang=js"
export * from "./BatchOrderCreate.vue?vue&type=script&lang=js"
import style0 from "./BatchOrderCreate.vue?vue&type=style&index=0&id=4c6c47c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6c47c3",
  null
  
)

export default component.exports